import React from 'react'
import '../../../styles/fontSizes.scss'
import "./capsuleButton.scss"
//
//
const CapsuleButton = ({className, color, bgColor, handle, textSize, children, value}) =>{
    
    return(
        <>
            <button value= {value} style ={{backgroundColor: bgColor, color: color}} onClick = {(e) => handle(e)} type = "button" className ={`${className?className:""} capsule-button__button font-size--${textSize?textSize:"1"}`}>
                {children}
            </button>
        </>
    )
}

export default CapsuleButton;